import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/WaterwaySignTypes/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/WaterwaySignTypes/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/WaterwaySignTypes/GetById`, payload),
    Add: (payload) => Repository.post(`/api/WaterwaySignTypes/Add`, payload),
    Edit: (payload) => Repository.post(`/api/WaterwaySignTypes/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/WaterwaySignTypes/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/WaterwaySignTypes/ChangeStatus`, payload),
}
